/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Purchases_YetInputs */

const en_no_purchases_yet = /** @type {(inputs: No_Purchases_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No purchases yet`)
};

const es_no_purchases_yet = /** @type {(inputs: No_Purchases_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay compras`)
};

const fr_no_purchases_yet = /** @type {(inputs: No_Purchases_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun achat pour le moment`)
};

const de_no_purchases_yet = /** @type {(inputs: No_Purchases_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Käufe`)
};

const ja_no_purchases_yet = /** @type {(inputs: No_Purchases_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ購入はありません`)
};

const zh_no_purchases_yet = /** @type {(inputs: No_Purchases_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无购买记录`)
};

const ar_no_purchases_yet = /** @type {(inputs: No_Purchases_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد مشتريات بعد`)
};

const id_no_purchases_yet = /** @type {(inputs: No_Purchases_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada pembelian`)
};

const it_no_purchases_yet = /** @type {(inputs: No_Purchases_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun acquisto`)
};

const ru_no_purchases_yet = /** @type {(inputs: No_Purchases_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет покупок`)
};

const pt_no_purchases_yet = /** @type {(inputs: No_Purchases_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma compra ainda`)
};

const ko_no_purchases_yet = /** @type {(inputs: No_Purchases_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 구매 내역이 없습니다`)
};

/**
* | output |
* | --- |
* | "No purchases yet" |
*
* @param {No_Purchases_YetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_purchases_yet = /** @type {((inputs?: No_Purchases_YetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Purchases_YetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_purchases_yet(inputs)
	if (locale === "es") return es_no_purchases_yet(inputs)
	if (locale === "fr") return fr_no_purchases_yet(inputs)
	if (locale === "de") return de_no_purchases_yet(inputs)
	if (locale === "ja") return ja_no_purchases_yet(inputs)
	if (locale === "zh") return zh_no_purchases_yet(inputs)
	if (locale === "ar") return ar_no_purchases_yet(inputs)
	if (locale === "id") return id_no_purchases_yet(inputs)
	if (locale === "it") return it_no_purchases_yet(inputs)
	if (locale === "ru") return ru_no_purchases_yet(inputs)
	if (locale === "pt") return pt_no_purchases_yet(inputs)
	return ko_no_purchases_yet(inputs)
});